import { Asset } from '@mkp/shared/models';

/**
 * Use this to append style to the asset itself
 */
export const ASSET_STYLES: Asset[] = [
  {
    name: 'jobs',
    styles: {},
  },
  {
    name: 'job-winner',
    styles: {
      width: '6rem',
    },
  },
  {
    name: 'jobscout24',
    styles: {
      width: '3rem',
    },
  },
  {
    name: 'jobup',
    styles: {},
  },
  {
    name: 'info',
    styles: {
      width: '24px',
    },
  },
  {
    name: 'open-in-view',
    styles: {
      width: '12px',
    },
  },
  {
    name: 'bullet',
    styles: {
      width: '8px',
      height: '8px',
    },
  },
  {
    name: 'jobup-square',
    styles: {
      width: '50px',
      height: '50px',
    },
  },
  {
    name: 'jobs-square',
    styles: {
      width: '50px',
      height: '50px',
    },
  },
  {
    name: 'js24-square',
    styles: {
      width: '50px',
      height: '50px',
      borderRadius: '12px',
    },
  },
  {
    name: 'ch-square',
    styles: {
      width: '1rem',
      height: '1rem',
    },
  },
];
